import _ from 'underscore';

import type { ILogMessage, ILogFilter, ILogFormatter } from '../types';

/**
 * Base listener class - defines the interface for custom listeners.
 * This can be extended by custom listeners
 */
export class Listener {
  filters: ILogFilter[] | Record<string, ILogFilter> = [];

  formatters: ILogFormatter[] | Record<string, ILogFormatter> = [];

  initialized: boolean;

  logs: ILogMessage[];

  constructor() {
    this.initialized = false;
    this.logs = [];
  }

  filterLogs(logMessage: ILogMessage): boolean {
    return _.any(this.filters, (filter: ILogFilter) => filter.check(logMessage));
  }

  formatLogs(logMessage: ILogMessage): ILogMessage {
    let formattedMsg = _.clone(logMessage);
    _.each(this.formatters, (formatter: ILogFormatter) => {
      formattedMsg = formatter.format(formattedMsg);
    });
    return formattedMsg;
  }

  write(_logMessage: ILogMessage): void {
    throw new Error('Not Implemented');
  }

  teardown(): void {
    _.noop();
  }
}
